import CircularProgress from "@material-ui/core/CircularProgress";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import _ from "lodash";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/nl";
import "moment/locale/pt";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import locales from "../../../_constants/locales";
import { buildLocaleQuery, parseLocaleQuery, resolveLocaleContext } from "../../../_utils/localeContext";
import CancelOrderItemsWindow from "../containers/_CancelOrderItemsWindow";
import CancelOrderWindow from "../containers/_CancelOrderWindow";
import EgiftCardsEmailWindow from "../containers/_EgiftCardsEmailWindow";
import InvoiceWindow from "../containers/_InvoiceWindow";
import OrderFetchErrorPage from "../containers/_OrderFetchErrorPage";
import ReturnOrderItemsWindow from "../containers/_ReturnOrderItemsWindow";
import ReturnOrderWindow from "../containers/_ReturnOrderWindow";
import { getRefundedItems, isPointOfSaleOrder } from "../Helpers/OderUtils";
import "../Styles/NewOrder.css";
import "../Styles/Order.css";
import AddressInformation from "./_AddressInformation";
import AuthorizedInformation from "./_AuthorizedInformation";
import FulfillmentInformation from "./_FulfillmentInformation";
import LineItemsInformation from "./_LineItemsInformation";
import OrderCancelledInformation from "./_OrderCancelledInformation";
import OrderOptions from "./_OrderOptions";
import OrderRefundedInformation from "./_OrderRefundedInformation";
import OrderRmaInformation from "./_OrderRmaInformation";
import OrderSummary from "./_OrderSummary";
import StatusInformation from "./_StatusInformation";

class Order extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancel_order_window_open: false,
            cancel_items_window_open: false,
            invoice_window_open: false,
            return_order_window_open: false,
            return_items_window_open: false,
            replace_window_open: false,
            replace_items_window_open: false,
            egiftcards_email_window_open: false
        };
    }

    getViewQueryParameters = () => {
        const resolved = this.getResolvedContext();

        if (JSON.stringify(this.props.store) !== JSON.stringify(resolved.store)) {
            this.props.setStore(resolved.store);
        }

        if (this.props.language !== resolved.language) {
            this.props.setLanguage(resolved.language);
        }

        if (this.props.country !== resolved.country) {
            this.props.setCountry(resolved.country);
        }
    };

    getResolvedContext = () => {
        return resolveLocaleContext({
            search: this.props.location.search,
            store: this.props.store,
            language: this.props.language,
            country: this.props.country,
            storeList: this.props.store_list,
            countryList: this.props.country_list
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.postMessageToParentWindow);

        this.props.resetLanguage();
        this.props.resetStore();
        this.props.resetCountry();
        this.props.reset();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        if (this.props.country_list.length === 0) {
            this.props.getCountries();
        }

        this.getViewQueryParameters();

        this.postMessageToParentWindow();
        this.props.get(this.props.match.params.order_id);
        moment.locale(this.props.language);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.postMessageToParentWindow);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.postMessageToParentWindow();

        if (prevProps.language !== this.props.language) {
            moment.locale(this.props.language);
        }

        if (
            this.props.language_list !== prevProps.language_list ||
            this.props.store_list !== prevProps.store_list ||
            this.props.country_list !== prevProps.country_list
        ) {
            this.getViewQueryParameters();
        }

        if (this.props.egift_cards_email_loading === false && prevProps.egift_cards_email_loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            }
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow = () => {
        const rootElement = document.getElementById("root");
        const height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);
        const data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    };

    getNavigationLocaleParams = () => {
        const localeQuery = parseLocaleQuery(this.props.location.search);
        const queryStores = Array.isArray(localeQuery.stores) ? localeQuery.stores : [];

        return {
            store: queryStores.length > 0 ? queryStores : this.props.store,
            language: localeQuery.language || this.props.language,
            country: localeQuery.country || this.props.country
        };
    };

    handleGoBackToSearch = () => {
        const query = buildLocaleQuery(this.getNavigationLocaleParams());
        this.props.history.push(`/embedded/search?${query}`);
    };

    handleCloseEgiftCardsEmailDialog = () => {
        this.setState({ egiftcards_email_window_open: false });
    };

    handleCloseInvoiceDialog = () => {
        this.setState({ invoice_window_open: false });
    };

    handleCloseCancelOrderItemsDialog = () => {
        this.setState({ cancel_items_window_open: false });
    };

    handleCloseCancelOrderDialog = () => {
        this.setState({ cancel_order_window_open: false });
    };

    handleCloseReturnOrderItemsDialog = () => {
        this.setState({ return_items_window_open: false });
    };

    handleCloseReturnOrderDialog = () => {
        this.setState({ return_order_window_open: false });
    };

    getBackgroundCss() {
        return this.state.cancel_order_window_open ||
            this.state.cancel_items_window_open ||
            this.state.invoice_window_open ||
            this.state.return_order_window_open ||
            this.state.return_items_window_open ||
            this.state.replace_items_window_open ||
            this.state.egiftcards_email_window_open
            ? " in-background"
            : "";
    }

    handleActionClick = (action, status) => {
        switch (action) {
            case "SEND_EGIFTCARDS_EMAIL":
                this.setState({ egiftcards_email_window_open: status });
                break;
            case "INVOICE":
                this.setState({ invoice_window_open: status });
                break;
            case "REQUEST_ASSISTANCE":
                window.open(this.getResolvedContext().locale.MISC.HELP_LINK, "_blank", "noopener,noreferrer");
                break;
            case "RETURN_ORDER_ITEMS":
                this.setState({ return_items_window_open: status });
                break;
            case "RETURN_ORDER":
                this.setState({ return_order_window_open: status });
                break;
            case "CANCEL_ORDER_ITEMS":
                this.setState({ cancel_items_window_open: status });
                break;
            case "CANCEL_ORDER":
                this.setState({ cancel_order_window_open: status });
                break;
            default:
                break;
        }
    };

    refreshOrder = () => {
        this.props.get(this.props.match.params.order_id);
        this.props.reset();
    };

    render() {
        const currentLanguage = this.getResolvedContext().locale || locales.CAEN.EN;
        const backgroundCss = this.getBackgroundCss();

        if (this.props.loading || this.props.language_list_loading || this.props.store_list_loading || this.props.country_list_loading) {
            return (
                <section className={`flex layout horizontal center-justified${backgroundCss}`}>
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                </section>
            );
        }

        if (_.isEmpty(this.props.order) || this.props.fetching_error) {
            return (
                <section className={`flex layout horizontal center-justified${backgroundCss}`}>
                    <OrderFetchErrorPage />
                </section>
            );
        }

        const refundedItems = getRefundedItems(this.props.order);
        const orderId = this.props.match.params.order_id;
        const totalEgiftCards = this.props.order.egift_cards ? this.props.order.egift_cards.length : 0;
        const pointOfSaleOrder = isPointOfSaleOrder(this.props.order);

        return (
            <section className={`flex ${backgroundCss}`}>
                <div className="order-main">
                    <div className="layout horizontal">
                        <button className="layout horizontal center justified back-to-search linked-text allow-focus" onClick={this.handleGoBackToSearch}>
                            <NavigateBeforeIcon style={{ fontSize: "22px", height: "20px", width: "20px" }} />
                            {currentLanguage.ORDER_PAGE.HEADER_SECTION.BACK_TO_SEARCH}
                        </button>
                    </div>
                    {!pointOfSaleOrder && (
                        <div className="status-bar-container">
                            <StatusInformation currentLanguage={currentLanguage} order={this.props.order} />
                        </div>
                    )}
                    <div className="body-info-container">
                        <div className="order-items-container">
                            {!pointOfSaleOrder && (
                                <React.Fragment>
                                    <AuthorizedInformation currentLanguage={currentLanguage} order={this.props.order} />
                                    <OrderCancelledInformation currentLanguage={currentLanguage} order={this.props.order} />
                                    <FulfillmentInformation currentLanguage={currentLanguage} order={this.props.order} />
                                </React.Fragment>
                            )}
                            <OrderRefundedInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <LineItemsInformation
                                currentLanguage={currentLanguage}
                                order={this.props.order}
                                ordered
                                refundedItems={refundedItems}
                                egiftcardsOpen={this.handleActionClick}
                            />
                            <LineItemsInformation currentLanguage={currentLanguage} order={this.props.order} refunded refundedItems={refundedItems} />
                            <OrderRmaInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <OrderOptions currentLanguage={currentLanguage} order={this.props.order} handleActionClick={this.handleActionClick} />
                        </div>
                        <div className="order-details-container">
                            <OrderSummary currentLanguage={currentLanguage} order={this.props.order} />
                            {!pointOfSaleOrder && (
                                <React.Fragment>
                                    <AddressInformation currentLanguage={currentLanguage} address={this.props.order.billing_address} addressType="BILLING" />
                                    <AddressInformation currentLanguage={currentLanguage} address={this.props.order.shipping_address} addressType="SHIPPING" />
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <OrderOptions currentLanguage={currentLanguage} order={this.props.order} handleActionClick={this.handleActionClick} mobile />
                    <EgiftCardsEmailWindow
                        currentLanguage={currentLanguage}
                        open={this.state.egiftcards_email_window_open}
                        order_id={orderId}
                        handleCloseEgiftCardsEmailDialog={this.handleCloseEgiftCardsEmailDialog}
                    />
                    <InvoiceWindow
                        currentLanguage={currentLanguage}
                        open={this.state.invoice_window_open}
                        order_id={orderId}
                        handleCloseInvoiceDialog={this.handleCloseInvoiceDialog}
                    />
                    <CancelOrderItemsWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.cancel_items_window_open}
                        order_id={orderId}
                        handleClose={this.handleCloseCancelOrderItemsDialog}
                        refreshOrder={this.refreshOrder}
                        total_egift_cards={totalEgiftCards}
                    />
                    <CancelOrderWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.cancel_order_window_open}
                        order_id={orderId}
                        handleClose={this.handleCloseCancelOrderDialog}
                        refreshOrder={this.refreshOrder}
                        total_egift_cards={totalEgiftCards}
                    />
                    <ReturnOrderItemsWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.return_items_window_open}
                        order_id={orderId}
                        handleClose={this.handleCloseReturnOrderItemsDialog}
                        refreshOrder={this.refreshOrder}
                        total_egift_cards={totalEgiftCards}
                    />
                    <ReturnOrderWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.return_order_window_open}
                        order_id={orderId}
                        handleClose={this.handleCloseReturnOrderDialog}
                        refreshOrder={this.refreshOrder}
                        total_egift_cards={totalEgiftCards}
                    />
                </div>
            </section>
        );
    }
}

export default withRouter(Order);
